import { useReveal } from "@/hooks/useReveal";

/**
 * Wrapper that applies the reveal animation as the element scrolls into view.
 * variant: "up" | "left" | "right" | "zoom"
 */
export default function Reveal({
  children,
  variant = "up",
  delay = 0,
  className = "",
  as: Tag = "div",
  ...rest
}) {
  const { ref, inView } = useReveal();
  const variantClass =
    variant === "left"
      ? "reveal-left"
      : variant === "right"
        ? "reveal-right"
        : variant === "zoom"
          ? "reveal-zoom"
          : "reveal";

  return (
    <Tag
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`${variantClass} ${inView ? "in-view" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
